export interface Config {
  apiEndpoint: string;
  environment: string;
}

export const config: Config = {
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT!,
  environment: process.env.REACT_APP_ENVIRONMENT!,
};
